import * as React from 'react'
import { SVGProps } from 'react'

const SvgYoutubeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 23 25' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#youtubeIcon_svg__a)'>
      <path
        d='M21.415 6.155c-.24-1.108-.947-1.981-1.845-2.278-1.626-.538-8.15-.538-8.15-.538s-6.522 0-8.149.538c-.897.297-1.604 1.17-1.844 2.278-.436 2.01-.436 6.202-.436 6.202s0 4.192.436 6.202c.24 1.108.947 1.945 1.844 2.241 1.627.539 8.15.539 8.15.539s6.523 0 8.15-.538c.897-.297 1.604-1.134 1.844-2.242.436-2.01.436-6.202.436-6.202s0-4.192-.436-6.202zM9.288 16.163V8.551l5.451 3.806-5.452 3.806z'
        fill='#3071ee'
      />
    </g>
    <defs>
      <clipPath id='youtubeIcon_svg__a'>
        <path fill='#fff' transform='translate(.42 .339)' d='M0 0h22v24H0z' />
      </clipPath>
    </defs>
  </svg>
)

export default SvgYoutubeIcon
